/**
 * Mints stable client-side ids for filter expressions, filter groups and
 * sort clauses, mirroring the `nextLevelId` pattern in `ContextEditorPage`.
 * The counter (not the clock) guarantees uniqueness when several filters are
 * minted within the same millisecond.
 */
let filterIdCounter = 0;

export const nextFilterId = (): string => {
  filterIdCounter += 1;
  return `flt_${Date.now().toString(36)}_${filterIdCounter.toString(36)}`;
};

/**
 * Assigns `nextFilterId()` to any item missing an `id`, leaving items that
 * already carry one untouched. Callers memoize on the input array's identity
 * (`useMemo(() => withStableIds(items), [items])`) so a normalised id stays
 * fixed across re-renders that don't replace the array — this must never run
 * inside a render `.map()`, which would hand a row a new key every render.
 */
export const withStableIds = <T extends { id?: string }>(items: T[]): T[] =>
  items.map((item) => (item.id ? item : { ...item, id: nextFilterId() }));
